import { TSitePage } from '../../../../types';

export const pages: Record<string, TSitePage> = {
  'default-initial': {
    id: 'default-initial',
    path: '*',
    html: 'default-page-loading',
  },
  'default-error': {
    id: 'default-error',
    path: '*',
    html: 'default-page-error',
  },
};
